import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/lib/Overlay';
import Popover from 'react-bootstrap/lib/Popover';

import { repeatUntil, repeatRepetitions, getDate } from '../../../lib/dates';
import * as styles from './styles.css';
import { ButtonSmall } from '../../Button';
import { withTranslation } from 'react-i18next';

class RepeatOverlay extends Component {
  static defaultProps = {
    placement: 'right',
  }

  static propTypes = {
    dates: PropTypes.arrayOf(PropTypes.string).isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    target: PropTypes.any,
    placement: PropTypes.oneOf(['left', 'right']),
  };

  constructor(props) {
    super(props);

    this.state = {
      spacing: 0,
      repetitions: 0,
      untilDate: getDate(new Date()),
      repeatMode: 'repetitions',
    };
  }

  handleRepeat = () => {
    const dates = this.state.repeatMode === 'date' ?
      repeatUntil(this.props.dates, this.state.untilDate, this.state.spacing)
      : repeatRepetitions(this.props.dates, this.state.repetitions - 1, this.state.spacing);

    this.props.onComplete(dates);
    this.props.onHide();
  }

  render() {
    const { show, onHide, target, placement } = this.props;
    return (
      <Overlay
        id="overload-bottom"
        rootClose
        show={show}
        onHide={onHide}
        placement={placement}
        target={target}
      >
        <Popover
          title={<div className={styles.repeatOverlayTitle}>
            <span>{this.props.t("Upprepa")}</span>
            <ButtonSmall
              icon="times"
              onClick={onHide}
            /></div>}
          style={{
            width: '400px',
            maxWidth: '400px',
          }}
          id="repeat-dates"
        >
          <div className={styles.repeatContainer}>
            <label>
              {this.props.t("Upprepa med mellanrum")}:
              <select
                className="form-control"
                value={this.state.spacing}
                onChange={event => this.setState({ spacing: parseInt(event.target.value) })}
              >
                <option value="0">{this.props.t("Inget mellanrum")}</option>
                <option value="1">{this.props.t("En vecka mellanrum")}</option>
                <option value="2">{this.props.t("Två veckor mellanrum")}</option>
                <option value="3">{this.props.t("Tre veckor mellanrum")}</option>
                <option value="3">{this.props.t("Fyra veckor mellanrum")}</option>
              </select>
            </label>


            <label htmlFor="repetitions">
              <div>
                <input
                  type="radio"
                  name="repeat-mode"
                  id="repetitions"
                  checked={this.state.repeatMode === 'repetitions'}
                  onChange={() => this.setState({ repeatMode: 'repetitions' })}
                />
                {this.props.t("Totalt antal gånger")}
              </div>
              <input
                disabled={this.state.repeatMode !== 'repetitions'}
                className="form-control"
                type="number"
                value={this.state.repetitions}
                onChange={event => this.setState({ repetitions: parseInt(event.target.value) })}
              />
            </label>
            <label htmlFor="date">
              <div>
                <input
                  type="radio"
                  name="repeat-mode"
                  id="date"
                  checked={this.state.repeatMode === 'date'}
                  onChange={() => this.setState({ repeatMode: 'date' })}
                />
                {this.props.t("Upprepa till datum")}
              </div>
              <input
                disabled={this.state.repeatMode !== 'date'}
                value={this.state.untilDate}
                className="form-control"
                type="date"
                onChange={event => this.setState({ untilDate: getDate(event.target.value) })}
              />
            </label>
          </div>
          <div className={styles.buttonContainer}>


            <ButtonSmall
              icon="floppy-o"
              onClick={this.handleRepeat}
              variant="primary"
            >
              {this.props.t("Upprepa")}
            </ButtonSmall>
          </div>
        </Popover>
      </Overlay>
    );
  }
}
export default withTranslation()(RepeatOverlay)